import Component from 'flarum/common/Component';
import goToPage from './goToPage';
import Pager from '../common/Pager';
import { postsPerPage, streamEnabled } from './config';
import { pagerMode, pagerWindow, pagerCounter, pagerJumpStream, pagerScrollOffset, pagerButtonSize, pagerIcons, mobileCompact, mobileSmall, mobileButtonSize, mobileHideJump, mobileHideCounter, pagerTrans, urlPage } from '../common/configApp';
export default class PostPaginator extends Component {
  view() {
    const stream = this.attrs.stream;
    if (!streamEnabled()) return null;
    const perPage = postsPerPage();
    const total = stream.count();
    const pageCount = Math.max(1, Math.ceil(total / perPage));
    if (pageCount <= 1) return null;
    const current = Math.min(pageCount, Math.floor(stream.visibleStart / perPage) + 1);
    const state = {
      pageSize: perPage,
      totalItems: total,
      getLocation: () => ({
        page: current
      }),
      goto: page => goToPage(stream, page, perPage),
      getPages: () => []
    };
    return m(Pager, {
      state: state,
      perPage: () => perPage,
      trans: pagerTrans,
      updateUrl: urlPage(),
      mode: pagerMode(),
      window: pagerWindow(),
      counter: pagerCounter(),
      jump: pagerJumpStream(),
      scroll: false,
      ariaLabel: pagerTrans('forum.post_stream.aria_label'),
      icons: pagerIcons(),
      scrollOffset: pagerScrollOffset(),
      buttonSize: pagerButtonSize(),
      mobileCompact: mobileCompact(),
      mobileSmall: mobileSmall(),
      mobileButtonSize: mobileButtonSize(),
      mobileHideJump: mobileHideJump(),
      mobileHideCounter: mobileHideCounter()
    });
  }
}
flarum.reg.add('stezkoy-pagify', 'forum/stream/PostPaginator', PostPaginator);